import PropTypes from 'prop-types'
import React from 'react'
import moment from 'moment'
import { FormattedMessage } from 'react-intl'

export class RelativeDate extends React.Component {
  static propTypes = {
    dateMoment: PropTypes.object.isRequired,
    pastOnly: PropTypes.bool,
    children: PropTypes.func
  }

  constructor (props) {
    super(props)
    const nowMoment = moment()
    this.state = {
      nowMoment
    }
  }

  componentDidMount () {
    this.timer = setInterval(() => {
      const nowMoment = moment()
      this.setState({
        nowMoment
      })
    }, 5000)
  }

  componentWillUnmount () {
    clearInterval(this.timer)
  }

  render () {
    const { dateMoment, pastOnly, children } = this.props
    const { nowMoment } = this.state

    const diff = dateMoment.diff(nowMoment, 'ms')
    if (pastOnly && diff > 0) {
      dateMoment.subtract(diff, 'ms')
    }

    const text = dateMoment.from(nowMoment)

    if (children) {
      return children({ dateMoment, nowMoment, diff, text })
    } else {
      return (
        <FormattedMessage
          id='DATE_FORMAT_FULL'
          values={{
            date: dateMoment.format('LLLL'),
            week: dateMoment.format('w'),
          }}
        >
          {formattedMessage =>
            <span title={formattedMessage}>{dateMoment.from(nowMoment)}</span>
          }
        </FormattedMessage>
      )
    }
  }
}

export default RelativeDate
